import { DocCardProps } from "@/types/components/DocCardProps";
import { ArticleModel } from "@/types/models/ArticleModel";
import { DocumentModel } from "@/types/models/DocumentModel";
import { PodcastSeriesModel } from "@/types/models/PodcastSeriesModel";
import { VideoModel } from "@/types/models/VideoModel";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "@inertiajs/react";
import DocumentImage from '@static/default/document-notification.png?quality=85&w=352&format=webp&imagetools';
import { ReactNode, useEffect, useRef, useState } from "react";

const LatestMaterial = ({ model, setRef, maxHeight }: { model: { type: string }; setRef: (el: HTMLParagraphElement) => void; maxHeight: number }) => {
    const ResolvedImage = () => {
        if (model.type == 'article') {
            const article = model as ArticleModel & { type: string };
            const path = article.hero
                ? `/patient${article.hero}/${article.id}/article`
                : '';

            return (
                <img src={path} alt="Post" loading='lazy' className='w-full h-full object-cover object-center rounded-2xl' />
            )
        }

        if (model.type == 'doc') {
            const path = (model as DocumentModel & { type: string }).hero ? '/patient' + (model as DocumentModel & { type: string }).hero + '/' + (model as DocumentModel & { type: string }).id + '/document' : '';

            if (!(model as DocumentModel & { type: string }).hero) {
                return (
                    <img src={DocumentImage} alt={`Okładka`} className="w-full h-full object-cover object-center rounded-2xl" />
                )
            }

            return (
                <img src={path} alt="Post" loading='lazy' className='w-full h-full object-cover object-center rounded-2xl' />
            )
        }

        if (model.type == 'video') {
            const path = (model as VideoModel & { type: string }).hero ? '/patient' + (model as VideoModel & { type: string }).hero + '/' + (model as VideoModel & { type: string }).id + '/video' : '';

            return (
                <img src={path} alt="Post" loading='lazy' className='w-full h-full object-cover object-center rounded-2xl' />
            )
        }

        if (model.type == 'podcast') {

            const series = model as PodcastSeriesModel & { type: string };
            const firstPodcast = series.podcasts?.[0];

            if (!firstPodcast?.hero) {
                return null;
            }

            const path = '/patient' + firstPodcast.hero + '/' + series.id + '/podcastSeries'

            return (
                <img src={path} alt="Post" loading='lazy' className='w-full h-full object-cover object-center rounded-2xl' />
            )
        }
    }

    const resolvedArticleType = () => {
        if (model.type == 'article') {
            return 'Artykuł'
        }
        if (model.type == 'video') {
            return 'Video'
        }
        if (model.type == 'doc') {
            return 'Dokument'
        }
        if (model.type == 'podcast') {
            return 'Podcast'
        }
    }

    const DynamicLink = ({ children }: { children: ReactNode }) => {
        if (model.type == 'article') {
            return (
                <Link href={route('front.patient.articleSingle', { article: (model as ArticleModel & { type: string }).slug })} className="border-1 border-royalPeriwinkle p-4 rounded-3xl w-full block bg-deepIndigo/70 h-full">
                    {children}
                </Link>
            )
        }
        if (model.type == 'video') {
            return (
                <Link href={route('front.patient.movies.single.player', { video: model })} className="border-1 border-royalPeriwinkle p-4 rounded-3xl w-full block bg-deepIndigo/70 h-full">
                    {children}
                </Link>
            )
        }
        if (model.type == 'doc') {
            return (
                <a target="_blank" href={route('front.patient.openDoc', { slug: (model as any).slug })} className="border-1 border-royalPeriwinkle p-4 rounded-3xl w-full block bg-deepIndigo/70 h-full">
                    {children}
                </a>
            )
        }
        if (model.type == 'podcast') {
            const series = model as PodcastSeriesModel & { type: string };
            const podcastSlug = series.podcasts?.[0]?.slug;

            if (!podcastSlug) {
                return (
                    <div className="border-1 border-royalPeriwinkle p-4 rounded-3xl w-full block bg-deepIndigo/70 h-full">
                        {children}
                    </div>
                );
            }

            return (
                <Link href={route('front.patient.podcasts.single', { podcastSeries: model, podcast: podcastSlug })} className="border-1 border-royalPeriwinkle p-4 rounded-3xl w-full block bg-deepIndigo/70 h-full">
                    {children}
                </Link>
            )
        }
    }

    return (
        <DynamicLink>
            <div>
                <div className="h-[160px] maxMd:h-[130px] w-full relative mb-2">
                    <ResolvedImage />
                    <div className="absolute top-0 right-0">
                        <div className="bg-deepIndigo/70 p-2 rounded-bl-2xl rounded-tr-2xl">
                            <p className="text-accordorange">{resolvedArticleType()}</p>
                        </div>
                    </div>
                </div>

                {(model as any).created_at &&
                    <div className="mb-1">
                        <p className="text-arcticMist text-12 tracking-[0.18px] text-left">{(model as any).created_at}</p>
                    </div>
                }


                <p
                    ref={setRef}
                    style={{ height: maxHeight ? `${maxHeight}px` : "auto" }}
                    className="text-arcticMist h5 tracking-[0.48px] text-left mb-2 break-words"
                >
                    {(model as any).name}
                </p>


                <div className="flex items-center gap-x-2 justify-between">

                    {(model as any).therapeutic_areas[0] &&
                        <div className={`max-w-max small-cat-tag tag-${(model as any).therapeutic_areas[0].name && (model as any).therapeutic_areas[0].name.toLowerCase()}`}>
                            <span>{(model as any).therapeutic_areas[0].name}</span>
                        </div>
                    }
                    {!!(model as any).is_pin_protected && <div className="size-10 bg-accordorange rounded-full flex items-center justify-center"><Icon icon={`ph:lock-key`} className="text-arcticMist origin-bottom animate-lock-wiggle-loop" width={24} /></div>}
                </div>
            </div>
        </DynamicLink>
    )
}

export default LatestMaterial;